// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-overlay[data-v-e503b304]{position:fixed;top:0;right:0;left:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:2147483647}.outer-center[data-v-e503b304]{flex-direction:row}.inner-center[data-v-e503b304],.outer-center[data-v-e503b304]{display:flex;justify-content:center;align-content:center}.inner-center[data-v-e503b304]{width:100%;flex-direction:column}", ""]);
// Exports
module.exports = exports;
